var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.859985,
    height: 38.008327,
    viewBox: "0 0 32.859985 38.008328",
    fill: "none",
    id: "svg19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.2449,3.57723 C 6.279,8.3709 2.7637,26.394 1.82887,31.2038 c -0.06126,0.3155 0.0046,0.6424 0.18313,0.9096 0.1786,0.2671 0.4555,0.4529 0.7704,0.517 l 19.731,3.9982 c 0.1576,0.0318 0.32,0.0322 0.4777,0.001 0.1578,-0.0312 0.3078,-0.0933 0.4415,-0.1827 0.1336,-0.0895 0.2483,-0.2045 0.3372,-0.3385 0.089,-0.1339 0.1506,-0.2842 0.1813,-0.442 l 2.7011,-13.9353 1.6842,0.2601 c 0.1986,0.0306 0.4014,-0.0172 0.5654,-0.1333 0.164,-0.1162 0.2764,-0.2915 0.3134,-0.4891 l 2.0539,-11.254 c 0.0184,-0.1 0.0168,-0.2026 -0.0046,-0.3019 C 31.2431,9.7135 31.2024,9.6193 31.1446,9.5357 31.0868,9.4522 31.013,9.3808 30.9276,9.3257 30.8422,9.2706 30.7467,9.233 30.6467,9.2148 L 29.1343,8.931 29.3323,7.84308 C 29.3892,7.52934 29.32,7.20581 29.1399,6.94271 28.9598,6.6796 28.6831,6.49815 28.37,6.43773 L 8.6577,2.62746 C 8.3447,2.56841 8.021,2.63494 7.7566,2.81267 7.4922,2.9904 7.3084,3.26505 7.2449,3.57723 Z",
    fill: "#a1a1a1",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.7119,4.03955 2.1968,31.6102 22.4394,36.2494 28.8189,8.873 Z",
    fill: "#e1e1e1",
    id: "path2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.3573,3.01318 1.71802,30.9597 22.2295,34.2223 26.7455,6.47865 Z",
    fill: "#ebebeb",
    id: "path3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_358_2902)",
    id: "g4",
    transform: "translate(-8,-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.3486,6.47559 10.4835,34.7918 31.2452,35.2872 32.0169,7.1876 Z",
    fill: "#ffffff",
    id: "path4"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.1053,10.5354 c 0,0.0548 -3.5725,0.0486 -7.9766,-0.0112 -4.404,-0.0597 -7.9753,-0.1518 -7.9753,-0.2054 0,-0.0535 3.5726,-0.0485 7.9778,0.0112 4.4053,0.0598 7.9753,0.1519 7.9741,0.2054 z",
    fill: "#575756",
    id: "path5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.2544,13.0411 c 0,0.0535 -3.5712,0.0485 -7.9765,-0.0112 -4.4053,-0.0598 -7.9753,-0.1531 -7.9741,-0.2067 0.0013,-0.0535 3.5713,-0.0485 7.9766,0.0112 4.4052,0.0598 7.9753,0.1531 7.974,0.2067 z",
    fill: "#575756",
    id: "path6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.4687,20.7201 c 0,0.0536 -3.5725,0.0486 -7.9766,-0.0112 -4.404,-0.0597 -7.9765,-0.1518 -7.9753,-0.2066 0.0013,-0.0548 3.5713,-0.0485 7.9778,0.0125 4.4065,0.061 7.9741,0.1518 7.9741,0.2053 z",
    fill: "#575756",
    id: "path7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.4687,18.2857 c 0,0.0535 -3.5725,0.0485 -7.9766,-0.0125 -4.404,-0.061 -7.9765,-0.1518 -7.9753,-0.2053 0.0013,-0.0536 3.5713,-0.0486 7.9778,0.0112 4.4065,0.0597 7.9741,0.158 7.9741,0.2066 z",
    fill: "#575756",
    id: "path8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.4687,15.8601 c 0,0.0536 -3.5725,0.0486 -7.9766,-0.0112 -4.404,-0.0597 -7.9765,-0.1518 -7.9753,-0.2054 0.0013,-0.0535 3.5713,-0.0485 7.9778,0.0112 4.4065,0.0598 7.9741,0.1519 7.9741,0.2054 z",
    fill: "#575756",
    id: "path9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.2287,23.43 c 0,0.0535 -3.5725,0.0485 -7.9765,-0.0112 -4.4041,-0.0598 -7.9753,-0.1519 -7.9753,-0.2054 0,-0.0536 3.5725,-0.0486 7.9777,0.0112 4.4053,0.0597 7.9753,0.1518 7.9741,0.2054 z",
    fill: "#575756",
    id: "path10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.1839,26.0953 c 0,0.0535 -3.5725,0.0485 -7.9765,-0.0112 -4.4041,-0.0598 -7.9766,-0.1531 -7.9753,-0.2067 0.0012,-0.0535 3.5712,-0.0485 7.9777,0.0112 4.4066,0.0598 7.9741,0.1531 7.9741,0.2067 z",
    fill: "#575756",
    id: "path11"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.1352,28.7591 c 0,0.0535 -3.5725,0.0485 -7.9778,-0.0112 -4.4053,-0.0598 -7.9753,-0.1519 -7.9741,-0.2054 0.0013,-0.0536 3.5713,-0.0486 7.9778,0.0112 4.4066,0.0597 7.9741,0.1518 7.9741,0.2054 z",
    fill: "#575756",
    id: "path12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m 23.7591,11.1081 c 2.7884,0 5.0489,-2.2627 5.0489,-5.05381 0,-2.79114 -2.2605,-5.0538 -5.0489,-5.0538 -2.7883,0 -5.0488,2.26266 -5.0488,5.0538 0,2.79111 2.2605,5.05381 5.0488,5.05381 z",
    fill: "#ff725e",
    id: "path13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 23.7641,11.1081 c 2.7912,0 5.0538,-2.2627 5.0538,-5.05381 0,-2.79114 -2.2626,-5.0538 -5.0538,-5.0538 -2.7911,0 -5.0538,2.26266 -5.0538,5.0538 0,2.79111 2.2627,5.05381 5.0538,5.05381 z",
    fill: "#e95039",
    id: "path14"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m 23.2026,11.1081 c 2.7884,0 5.0489,-2.2627 5.0489,-5.05381 0,-2.79114 -2.2605,-5.0538 -5.0489,-5.0538 -2.7884,0 -5.0488,2.26266 -5.0488,5.0538 0,2.79111 2.2604,5.05381 5.0488,5.05381 z",
    fill: "#e30917",
    id: "path15"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m 23.2404,3.07715 h -0.0722 c -0.143,0 -0.2589,0.11592 -0.2589,0.25891 V 8.7745 c 0,0.143 0.1159,0.2589 0.2589,0.2589 h 0.0722 c 0.143,0 0.2589,-0.1159 0.2589,-0.2589 V 3.33606 c 0,-0.14299 -0.1159,-0.25891 -0.2589,-0.25891 z",
    fill: "#fafafa",
    id: "path16"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m 20.2274,6.02024 v 0.0697 c 0,0.14368 0.1165,0.26016 0.2602,0.26016 h 5.4322 c 0.1437,0 0.2602,-0.11648 0.2602,-0.26016 v -0.0697 c 0,-0.14369 -0.1165,-0.26017 -0.2602,-0.26017 h -5.4322 c -0.1437,0 -0.2602,0.11648 -0.2602,0.26017 z",
    fill: "#fafafa",
    id: "path17"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs19"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_358_2902",
    x: 0.29743901,
    y: 0.36393699,
    width: 41.905602,
    height: 49.183701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    id: "feFlood17"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    id: "feColorMatrix17"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.07443,
    id: "feOffset17"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09304,
    id: "feGaussianBlur17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    id: "feComposite17"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    id: "feColorMatrix18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_358_2902",
    id: "feBlend18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_358_2902",
    result: "shape",
    id: "feBlend19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublications);
export default __webpack_public_path__ + "static/media/publications.5d8db38b9e631536cc5cdb16f736c91b.svg";
export { ForwardRef as ReactComponent };